import { render } from "./subfacet.vue?vue&type=template&id=119e6976&scoped=true"
import script from "./subfacet.vue?vue&type=script&lang=js"
export * from "./subfacet.vue?vue&type=script&lang=js"

import "./subfacet.vue?vue&type=style&index=0&id=119e6976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119e6976"]])

export default __exports__